import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { ProjectsService } from '../../services/projects-proposals-service/projects-proposals.service';
import { ListService } from '../services/list.service';

import { FilterDialogComponent } from './filter-dialog/filter-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'mcrit-gestio-projects-filters',
  templateUrl: 'projects-filters.component.html',
  styleUrls: ['projects-filters.component.css'],
  providers: [ProjectsService]
})
export class ProjectsFiltersComponent implements OnInit {
  @Input() tipus: string;
  @Input() validFilters: Array<any>;
  @Output() changeFilter = new EventEmitter();

  public filterModel: any;
  public dataLists: Array<any>;
  public filterText: { [key: string]: string } = {};

  constructor(public translate: TranslateService, public languageService: LanguageService, private listService: ListService,private projectsService: ProjectsService, private dialog: MatDialog) {}

  getDatalist(value: any): string | null {
   //console.log(value);
   const text = this.filterModel[value.name];
   return (value.autocomplete && text && text.length > 3)
     ? value.autocomplete
     : null;
  }

  textToModel(value: any) {
  const text = this.filterText[value.name];
    if (!text) {
      this.filterModel[value.name] = { mode: 'ANY', type: value.type, values: [] };
      return;
    }

    this.filterModel[value.name] = {
      mode: 'ANY',
      type: value.type,
      values: text
        .split(',')
        .map(v => v.trim())
        .filter(v => v)
    };
  }


  public sendActiveFilters() {

    Object.keys(this.filterModel)//Recupera els valors dels camps del filtre
      .filter(key => (this.filterModel[key] === 0 || this.filterModel[key] && this.filterModel[key] !== ''))
      .forEach(key => this.listService.valFiltres[key] = this.filterModel[key]);

    this.listService.activeFilters = this.filterModel;
    this.changeFilter.emit();
  }

  public resetActiveFilters(){
    this.listService.activeFilters = {};
    //Inicialitza els checkboxes a l'estat inicial. Hauria de fer bucle pels check's de projectFilters i activar els true (si cal)
    if(this.tipus == 'proposal' || this.tipus == 'proposalpe')this.filterModel = { statePresented: false };else this.filterModel = { stateActive: false };
    this.sendActiveFilters();
  }

  ngOnInit(){
    let requestedAutocompletes = [];
    //Cerca els camps select/autocompletes

    this.filterModel = this.validFilters.reduce((acum, curr) => {
      curr.inputs.forEach(inputGroup => {
        switch (inputGroup.type) {
          case 'select':
            acum[inputGroup.name] = (inputGroup.value ? inputGroup.value : null);
            break;
          default:
            inputGroup.values.forEach(input => {
              if(input.autocomplete)requestedAutocompletes.push(input.autocomplete);
              acum[input.name] = (input.value ? input.value : null);
            });
        }
      });
      return acum;
    }, {});
    //Omple els valors per defecte dels camps autocomplete
    this.dataLists = requestedAutocompletes.map(id => { return { id: id, options: this.projectsService.getAutocomplete(id) }; });

    //Quan tenim una cerca desada
    if(Object.keys(this.listService.activeFilters).length !== 0)this.filterModel = this.listService.activeFilters;
    this.sendActiveFilters();
  }

  getWidthByType(type: string): string {
    switch (type) {
      case 'date': return '250px';
      case 'value': return '250px';
      case 'text': return '270px';
      default: return '185px'; // Default
    }
  }

  //Selector condicions
  public getFilterLabel(field: any): string {
    const f = this.filterModel[field.name];
    let op = '';

    if(field.type == 'text'){
      if (!f || f.values.length === 0) return '';
      op = f.mode === 'ANY' ? 'OR' : 'AND';
      return `${op}: ${f.values.join(', ')}`;
    }

    if(field.type == 'value'){
      if (!f || (!f.min && !f.max)) return '';
      op = 'BETWEEN';
      return `${op}: ${f.min}, ${f.max}`;
    }

    if(field.type == 'date'){
      op = 'DATE';
      return `${op}: ${f.dateStart}, ${f.dateEnd}`;
    }

  }

  public openFilterDialog(value: any) {
    const current = this.filterModel[value.name] ?? {
      mode: 'ANY',
      type: value.type,
      values: [],
      dateStart: null,
      dateEnd: null,
      min: null,
      max: null
    };
    const dialogRef = this.dialog.open(FilterDialogComponent, {
      width: '400px', 
      data: JSON.parse(JSON.stringify(current))
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
       if (result.type == "date"){
         result.dateStart = result.dateStart?this.formatDate(result.dateStart):null;
         result.dateEnd = result.dateEnd?this.formatDate(result.dateEnd):null;
       }
       this.filterModel[value.name] = result;
       this.filterText[value.name] = this.getFilterLabel(value);
      }
    });
  }

  formatDate(date: Date | undefined): string | null {
    if (!date) return null;
      const options: Intl.DateTimeFormatOptions = { month: 'short', day: '2-digit', year: 'numeric' };
      return date.toLocaleDateString('en-US', options).replace(',', '');
  }
}
